import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import "./DoraDimensionsPicker.scss";
export const DoraDimensionsPicker = (props) => {
    const { onChange, value: propsValue, error, disabled, step = 0.01 } = props;
    const { t } = useTranslation(["components"]);
    const [value, setValue] = useState({
        length: propsValue?.length || "",
        width: propsValue?.width || "",
        height: propsValue?.height || "",
    });
    useEffect(() => {
        if (propsValue.length !== value.length ||
            propsValue.width !== value.width ||
            propsValue.height !== value.height) {
            setValue(propsValue);
        }
    }, [propsValue, setValue]);
    const onFieldChange = (field, e) => {
        const newValue = { ...value, [field]: e.target.value };
        setValue(newValue);
        onChange(newValue);
    };
    const componentClasses = classnames("dora-dimensions-picker", {
        "dora-dimensions-picker--error": error,
        "dora-dimensions-picker--disabled": disabled,
    });
    return (_jsxs("div", { className: componentClasses, children: [_jsx("input", { type: "number", step: step, value: value.length, disabled: disabled, onChange: (e) => onFieldChange("length", e), placeholder: t("components:dimensions.length") }), _jsx("span", { className: "dora-dimensions-picker__separator", children: "x" }), _jsx("input", { type: "number", step: step, value: value.width, disabled: disabled, onChange: (e) => onFieldChange("width", e), placeholder: t("components:dimensions.width") }), _jsx("span", { className: "dora-dimensions-picker__separator", children: "x" }), _jsx("input", { type: "number", step: step, value: value.height, disabled: disabled, onChange: (e) => onFieldChange("height", e), placeholder: t("components:dimensions.height") })] }));
};
export const UFDoraDimensionsPicker = (props) => {
    const { registerLength, registerWidth, registerHeight, error, disabled, step = 0.01, } = props;
    const { t } = useTranslation(["components"]);
    const componentClasses = classnames("dora-dimensions-picker", {
        "dora-dimensions-picker--error": error,
        "dora-dimensions-picker--disabled": disabled,
    });
    return (_jsxs("div", { className: componentClasses, children: [_jsx("input", { type: "number", step: step, ...registerLength, disabled: disabled, placeholder: t("components:dimensions.length") }), _jsx("span", { className: "dora-dimensions-picker__separator", children: "x" }), _jsx("input", { type: "number", step: step, ...registerWidth, disabled: disabled, placeholder: t("components:dimensions.width") }), _jsx("span", { className: "dora-dimensions-picker__separator", children: "x" }), _jsx("input", { type: "number", step: step, ...registerHeight, disabled: disabled, placeholder: t("components:dimensions.height") })] }));
};
//# sourceMappingURL=DoraDimensionsPicker.js.map